import { useMemo, useState } from 'react';
import type { Announcement } from '../services/sync/ServerApi';
import { Icon, Symbols } from './icons';

interface Props {
  announcements: Announcement[];
  busy?: boolean;
  onDismiss: (announcement: Announcement) => void;
}

const LEVEL_LABEL: Record<Announcement['level'], string> = {
  info: 'Comunicado', success: 'Novidade', warning: 'Atenção', critical: 'Importante',
};

export function AnnouncementCenter({ announcements, busy = false, onDismiss }: Props) {
  const [expanded, setExpanded] = useState(false);
  const ordered = useMemo(() => [...announcements].sort((a, b) => {
    const weight = { critical: 0, warning: 1, success: 2, info: 3 } as const;
    return weight[a.level] - weight[b.level] || b.createdAt.localeCompare(a.createdAt);
  }), [announcements]);
  if (ordered.length === 0) return null;
  const primary = ordered[0];

  return <section className={`announcement-center level-${primary.level}`} aria-label="Comunicados OWDEX">
    <div className="announcement-leading"><span className="announcement-icon"><Icon>{primary.level === 'warning' || primary.level === 'critical' ? Symbols.alert : Symbols.megaphone}</Icon></span></div>
    <div className="announcement-copy">
      <div className="announcement-eyebrow"><span>{LEVEL_LABEL[primary.level]}</span>{primary.organizationName && <em>{primary.organizationName}</em>}</div>
      <strong>{primary.title}</strong>
      <p>{primary.body}</p>
    </div>
    <div className="announcement-actions">
      {ordered.length > 1 && <button type="button" className="announcement-count" onClick={() => setExpanded((value) => !value)}>{ordered.length} comunicados</button>}
      {primary.dismissible && <button type="button" className="announcement-dismiss" disabled={busy} onClick={() => onDismiss(primary)} title="Dispensar comunicado"><Icon>{Symbols.close}</Icon></button>}
    </div>
    {expanded && ordered.length > 1 && <div className="announcement-stack">
      {ordered.slice(1).map((item) => <article key={item.id} className={`announcement-stack-item level-${item.level}`}>
        <div><small>{LEVEL_LABEL[item.level]}{item.organizationName ? ` · ${item.organizationName}` : ''}</small><strong>{item.title}</strong><p>{item.body}</p></div>
        {item.dismissible && <button type="button" onClick={() => onDismiss(item)} disabled={busy} aria-label={`Dispensar ${item.title}`}><Icon>{Symbols.close}</Icon></button>}
      </article>)}
    </div>}
  </section>;
}
